import React, {ForwardedRef, forwardRef} from 'react';
import clsx from 'clsx';

export const IconButton = forwardRef(
  (
    {
      onClick,
      children,
      ariaLabel,
      ariaRole,
      testid,
    }: {
      children: React.ReactNode;
      onClick?: () => void;
      ariaLabel?: string;
      ariaRole?: string;
      testid?: string;
    },
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <button
        data-testid={testid}
        ref={ref}
        type="button"
        className={clsx(
          'w-12 h-12 rounded-full flex items-center justify-center border-2 border-blue-500 group cursor-pointer',
          'enabled:hover:bg-blue-500 enabled:hover:text-white',
        )}
        onClick={onClick}
        aria-label={ariaLabel}
        role={ariaRole}
      >
        {children}
      </button>
    );
  },
);
